import React from 'react';
import { Box, Text, Badge, HStack } from '@chakra-ui/react';
import { ITableResponse, ICatalogResponse } from '../../../../models/sessions';
import { HeatmapCell } from '../HeatmapCell';

interface PerSessionViewProps {
  table: ITableResponse;
  catalog: ICatalogResponse;
}

/**
 * Modalità PER_SESSION — 1 riga per (atleta×sessione), date desc.
 */
export const PerSessionTableView: React.FC<PerSessionViewProps> = ({
  table,
  catalog,
}) => {
  const columnDefs = table.meta.columns.map((id) =>
    catalog.metrics.find((m) => m.id === id),
  );
  const meta = table.meta as any;

  return (
    <Box>
      <HStack p={3} gap={3} bg="blue.50" borderBottom="1px solid" borderColor="blue.200">
        <Badge colorPalette="blue" fontSize="md" px={3} py={1}>
          {meta.totalSessions ?? table.rows.length} sessioni
        </Badge>
        <Text fontSize="sm" color="gray.700">
          Log cronologico · ordinamento data discendente
        </Text>
      </HStack>

      {table.rows.length === 0 ? (
        <Box p={8} textAlign="center" color="gray.500">
          Nessuna sessione nel periodo
        </Box>
      ) : (
        <Box overflowX="auto" bg="var(--c-card-bg)">
          <Box as="table" width="100%" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
            <thead>
              <tr style={{ background: 'var(--c-navy-1)', color: 'var(--c-card-bg)' }}>
                <th style={{ padding: 10, textAlign: 'left', minWidth: 160 }}>Data · sessione</th>
                <th style={{ padding: 10, textAlign: 'left', minWidth: 180 }}>Atleta</th>
                {columnDefs.map((def) => (
                  <th
                    key={def?.id}
                    style={{
                      padding: '8px',
                      textAlign: 'center',
                      fontSize: 10,
                      textTransform: 'uppercase',
                    }}
                  >
                    {def?.label}
                    <div style={{ fontSize: 9, opacity: 0.7 }}>
                      {def?.unit}
                      {table.meta.unitMode === 'per_min' && def?.isVolumeMetric ? '/min' : ''}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {table.rows.map((row, idx) => {
                const sessionDate = (row as any)._sessionDate;
                const sessionType = (row as any)._sessionType;
                const sessionName = (row as any)._sessionName;
                const isMatch = sessionType === 'match';
                return (
                  <tr
                    key={`${row.athleteId}-${(row as any)._sessionId ?? idx}`}
                    style={{
                      background: isMatch ? '#dbeafe' : (idx % 2 === 0 ? 'var(--c-row-stripe)' : 'var(--c-card-bg)'),
                    }}
                  >
                    <td style={{ padding: 10 }}>
                      <Text fontSize="11px" color="gray.500" textTransform="uppercase" letterSpacing="0.05em">
                        {sessionDate}
                      </Text>
                      <Text fontWeight={600}>
                        {sessionName ?? sessionType}
                      </Text>
                      {isMatch && (
                        <Badge colorPalette="blue" size="sm">PARTITA</Badge>
                      )}
                    </td>
                    <td style={{ padding: 10 }}>
                      {row.athleteName}
                      {row.position && (
                        <Text fontSize="xs" color="gray.500">{row.position}</Text>
                      )}
                    </td>
                    {columnDefs.map((def) => (
                      <td key={def?.id} style={{ padding: '6px 8px', borderBottom: '1px solid #e5e7eb' }}>
                        <HeatmapCell
                          value={def ? row.values[def.id] : undefined}
                          strategy={def ? table.meta.heatmap[def.id] : undefined}
                          decimals={def?.decimals ?? 0}
                        />
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </Box>
        </Box>
      )}
    </Box>
  );
};
